import calcrem from '@adecco/base-app/src/utilities/calcrem/calcrem';
import { Theme } from '@adecco/base-app/src/constants/themes/defaultTheme/themeType';

const defaultTheme: Theme = {
  aligns: {
    jobFactItem: 'center',
  },
  backgrounds: {
    aboutUs: 'rgb(252, 252, 252)',
    benefit: '#ffffff',
    cardIconContainer: '#ffffff',
    checkBox: 'white',
    circleIcon: '#5cb85c',
    contact: '#001d67',
    contactLink: '#001752',
    contactLinkHover: '#dddddd',
    contactLinkItem: '#EDEDED',
    faqItem: '#FFFFFF',
    input: '#FFFFFF',
    inputFocus: '#FFFFFF',
    phoneWithCountry: '#FFFFFF',
    jobFactItem: '#ededed',
    jobListTeaserFooter:
      'radial-gradient(circle, rgba(224, 224, 224, 1) 0%, rgba(255, 255, 255, 0) 100%)',
    logoButton: 'rgb(252, 252, 252)',
    processNumber: '#FFD200',
    progressBar: 'transparent',
    progressBarDone: 'rgb(92, 184, 92)',
    salaryScale: '#efefef',
    progressBarItem: {
      done: 'transparent',
      current: 'transparent',
      future: '#f8f8f8',
      finished: 'transparent',
    },
    searchBox: 'linear-gradient(90deg, #da291c 50%, #da291c 100%)',
    smallGhostButton: 'transparent',
    spacer: 'linear-gradient(0deg, #FFFFFF 0%, #EDEDED 100%)',
    speechBubbleWrapper: '#7cc67c',
    tab: 'linear-gradient(-180deg, rgba(238, 238, 238, 0) 0%, rgba(216, 216, 216, 0.16) 100%)',
    teaser: '#ffffff',
    wrapper: 'rgb(255, 255, 255)',
  },
  blendModes: {
    processNumber: 'initial',
  },
  borders: {
    aboutUs: '1px solid rgba(151, 151, 151, 0.35)',
    backBarLink: '1px solid #e6e6e6',
    backBarLinkBlack: '2px solid #191919',
    black: '1px solid #000',
    bullet: '1px solid #aaa',
    callToAction: '2px solid rgba(218, 41, 28, 0.5)',
    checkBox: '2px solid #afafaf',
    checkMarkDarkGrey: '0.5px solid #555555',
    checkMarkPrimary: '0.5px solid #da291c',
    circleIconWidth: '1px',
    errorField: 'none',
    form: 'none',
    header: '1px solid rgba(0, 0, 0, 0.1)',
    helpText: '0.5px solid rgb(175, 175, 175)',
    inputField: 'none',
    link: '1px solid #111',
    logoButton: '1px solid #eee',
    materialDown: 'none',
    panel: 'none',
    progressBar: '1px solid #BDBCBC',
    progressBarItemColor: '#BDBCBC',
    progressBarItemWidth: '1px',
    radioButton: '0.5px solid #555555',
    radioButtonError: '0.5px solid #da291c',
    regular: 'none',
    searchButton: '1.5px solid #FFFFFF',
    secondFooter: '1px solid #c8c7c7',
    smallGhostButton: '1px solid #333',
    speechBubbleAfter: '8px 6px 0 6px',
    teaser: '1px solid #e6e6e6',
    wrapper: '1px solid rgb(225,225,225)',
  },
  boxShadow: {
    boxShadow: '0px 8px 10px 0px rgba(0, 0, 0, 0.08)',
    brandBarWrapper: '0 4px 8px 0 rgba(213, 213, 213, 0.5)',
    checkBox: 'none',
    cardInfo: '0px 20px 29px rgba(0, 0, 0, 0.2)',
    contact: 'none',
    callToAction: '0px 24px 38px rgba(0, 0, 0, 0.3)',
    fact: 'none',
    factHeader: '0px 20px 29px rgba(0, 0, 0, 0.2)',
    faqItem: '0px 24px 38px rgba(0, 0, 0, 0.3)',
    faqItemOpen: '0px 24px 38px rgba(0, 0, 0, 0.3)',
    fileField: 'inset 2px 2px 3px 0 rgba(0, 0, 0, 0.1)',
    helpText: 'inset 2px 2px 3px 0 rgba(0, 0, 0, 0.05)',
    imageTeaser: '0 5px 15px 0 rgba(0, 0, 0, 0.1)',
    input: '0px 10px 38px rgba(0, 0, 0, 0.3)',
    materialMid: '0px 10px 38px rgba(0, 0, 0, 0.3)',
    materialUp: 'none',
    materialUpWideScreen: '0px 24px 38px rgba(0, 0, 0, 0.3)',
    media: '10px 15px 0px 0px rgba(250, 210, 209, 0.75)',
    mediaWideScreen: '-20px 20px 0px 0px rgba(250, 210, 209, 0.75)',
    pageHead: 'none',
    pageHeadContainer: 'none',
    processItemImage: '0px 11px 27px rgba(0, 0, 0, 0.39)',
    thankYouTeaserImage: '0px 24px 38px rgba(0, 0, 0, 0.3)',
    speechBubbleWrapper: '0px 10px 10px 0px rgba(0, 0, 0, 0.11)',
  },
  colors: {
    infoText: '#000000',
    infoTextIcon: '#000000',
    footerInfoText: '#000',
    activeBullet: '#ffffff',
    baseButton: '#000000',
    benefitHeadline: '#333',
    black: '#191919',
    bullet: '#e6e6e6',
    cardInfoHeadline: '#191919',
    checkTextError: '#da291c',
    contact: 'white',
    contactLink: 'white',
    contactLinkItem: '#000000',
    error: 'rgb(239, 46, 36)',
    errorLink: 'rgb(239, 46, 36)',
    faqItemOpenElement: '#000000',
    faqHeadline: '#000000',
    footerLink: '#000000',
    footerLinkHover: '#FFD602',
    green: '#7cc67c',
    headline: '#191919',
    infoIconBackground: '#001D67',
    infoIconEmphasizedBackground: '#001D67',
    infoIconEmphasizedForeground: '#FFFFFF',
    infoIconForeground: '#FFFFFF',
    inputText: '#333',
    jobLink: '#da291c',
    jobListItem: '#191919',
    label: '#000',
    lightBlack: '#1a1919',
    lighterGrey: '#eee',
    lightestGrey: '#f8f8f8',
    cvLink: '#3AAEF4',
    lightGrey: '#e6e6e6',
    location: '#333',
    medGrey: '#CFCFCF',
    paragraph: '#000000',
    primary: '#FFD602',
    inputFieldError: 'none',
    processNumber: '#000000',
    processItemParagraph: '#000000',
    processItemHeadline: '#FFD200',
    progressBarIcon: {
      done: 'rgb(85, 85, 85)',
      current: 'rgb(85, 85, 85)',
      future: 'rgb(151, 151, 151)',
      finished: '#FFFFFF',
    },
    progressBarItem: {
      done: '#000000',
      current: '#000000',
      future: '#000000',
      finished: '#000000',
    },
    progressBarItemContent: {
      done: 'rgb(85, 85, 85)',
      current: 'rgb(85, 85, 85)',
      future: 'rgb(151, 151, 151)',
      finished: 'rgb(85, 85, 85)',
    },
    rgbblack: '0,0,0',
    smallGhostButton: '#333',
    statusBarYellow: '#ffc15d',
    subline: '#333',
    success: '#5cb85c',
    text: '#333',
    textGrey: '#aaa',
    secondaryButton: '#aaa',
    textlink: '#000000',
    thankYouTeaserHeadline: '#FFD602',
    twoColParagraph: '#e6e6e6',
    white: '#FFFFFF',
    baseButtonText: '#000000',
    requiredStar: 'rgb(239, 46, 36)',
  },
  displays: {
    backBarLink: 'inline-block',
    backToSearchMobileLink: 'none',
    checkboxContainer: 'flex',
    factImage: 'block',
    infoButton: 'row',
    faqLeftOpenButton: 'none',
    formLanguage: 'none',
    jobFactList: 'flex',
    processNumber: 'flex',
    progressBarDone: 'inline-block',
    searchBox: 'none',
    thankYouTeaserList: 'flex',
  },
  flexDirections: {},
  fonts: {
    cardInfoHeadline: 'Roboto Bold, Helvetica, Arial, sans-serif',
    Copy: 'Roboto, Helvetica, Arial, sans-serif',
    factSubline: 'Roboto Bold, Helvetica, Arial, sans-serif',
    formHead: 'Roboto Bold, Helvetica, Arial, sans-serif',
    formHeadWideScreen: 'Roboto Bold, Helvetica, Arial, sans-serif',
    Headline: 'Roboto, Helvetica, Arial, sans-serif',
    HeadlineBold: 'Roboto Bold, Helvetica, Arial, sans-serif',
    textLink: 'Roboto Bold, Helvetica, Arial, sans-serif',
    input: 'Roboto Bold, Helvetica, Arial, sans-serif',
    paragraphLink: 'Roboto Bold, Helvetica, Arial, sans-serif',
  },
  fontSizes: {
    benefitHeadline: calcrem(18),
    benefitHeadlineWideScreen: calcrem(24),
    brandedHeadline: calcrem(32),
    brandedHeadlineWideScreen: calcrem(48),
    button: calcrem(18),
    buttontext: calcrem(16),
    buttonWideScreen: calcrem(24),
    cardIconHeadline: calcrem(18),
    cardImageHeadline: calcrem(18),
    checkboxLabel: calcrem(16),
    checkText: calcrem(12),
    contactLinkText: '12.94px',
    dataBadge: calcrem(19),
    dateParagraph: calcrem(12),
    dateParagraphWideScreen: calcrem(12),
    errorMessageText: calcrem(12),
    errorMessageTextHeading: calcrem(12),
    factHeadline: calcrem(86),
    factListHeadlineWideScreen: calcrem(40),
    factSubline: calcrem(20),
    faqHeadline: calcrem(32),
    faqItemHeadline: '18px',
    faqItemHeadlineWideScreen: calcrem(24),
    formHead: calcrem(32),
    formHeadWideScreen: calcrem(48),
    footerCopy: calcrem(12),
    headline1: calcrem(32),
    headline1WideScreen: calcrem(48),
    headline2: calcrem(32),
    headline2WideScreen: calcrem(40),
    headline3: calcrem(24),
    headline4: calcrem(18),
    headlineTeaser: calcrem(20),
    headline4Widescreen: calcrem(24),
    imageTeasersHeadlineWideScreen: calcrem(40),
    infoText: calcrem(12),
    infoDropDown: calcrem(12),
    jobContentHeadlineWideScreen: calcrem(40),
    jobHeaderHeadline: '40px',
    jobHeaderHeadlineWideScreen: '48px',
    jobSearchListHeadline: '28px',
    jobSearchListHeadlineWideScreen: '32px',
    jobTeaserDate: calcrem(12),
    label: calcrem(16),
    landingPageHeadline: '32px',
    landingPageHeadlineWideScreen: '48px',
    landingPageParagraph: '12px',
    link: calcrem(12),
    linkList: calcrem(16),
    locationList: calcrem(12),
    logoButtonHeadline: '32px',
    logoButtonHeadlineWideScreen: '40px',
    mediaHeadline: '32px',
    mediaHeadlineWideScreen: '40px',
    placeholder: calcrem(18),
    processHeadlineWideScreen: calcrem(40),
    processItemNumber: calcrem(20),
    processItemParagraph: calcrem(16),
    processSubline: '28px',
    processSublineWideScreen: '32px',
    sidebarButton: calcrem(24),
    smallButton: '16px',
    speechBubble: '20px',
    subline: calcrem(28),
    sublineWideScreen: calcrem(32),
    tab: '20px',
    text: calcrem(12),
    textWideScreen: calcrem(12),
    thankYou: '40px',
    thankYouTeaser: '16px',
    thankYouWideScreen: '48px',
    typographyHeadline2: calcrem(28),
    typographyHeadline2WideScreen: calcrem(32),
  },
  fontStyles: {
    infoDropdown: 'normal',
    infoTextText: 'normal',
  },
  fontWeights: {
    button: '600',
    faqHeadline: '800',
    headline: 'bold',
    jobFactItem: '600',
    landingDiscription: 'normal',
    landingHeadline: 'normal',
    link: '400',
    listParagraph: 'bold',
    locationList: '600',
    locationListHeadline: '600',
    page: '100',
    processItemNumber: '600',
    speechBubble: '600',
    tab: '500',
    textLink: 'bold',
    twoColParagraphStrong: '600',
  },
  headerSpacing: {
    boxShadowOffest: '2px',
    inputCustomHeight: '48px',
    logoHeight: '26px',
    searchBoxFakeHeight: '80px',
    searchBoxFakeHeightWithSearch: '80px',
    searchBoxFakeMarginBottom: '130px',
    searchBoxPaddingBottom: '30px',
    searchBoxPaddingTop: '45px',
    searchIconExtraPadding: '2px',
  },
  gaps: {
    jobFactList: '1rem',
    factList: '37px',
  },
  heights: {
    checkMark: calcrem(24),
    brandBarAfter: '6px',
    brandBarAfterWideScreen: '8px',
    faqItem: '82px',
    faqItemOpenElement: '4px',
    input: '60px',
    jobFactItem: '42px',
    jobSearchInput: '46px',
    spacerMax: '700px',
    jobFactItemIconContainer: '20px',
  },
  hyphens: {
    jobHeaderHeadline: 'auto',
  },
  lineHeights: {
    benefitHeadline: calcrem(20),
    benefitHeadlineWideScreen: calcrem(26),
    buttontext: calcrem(32),
    contactParagraph: '18px',
    dateParagraph: calcrem(16),
    dateParagraphWideScreen: calcrem(18),
    errorText: calcrem(17),
    fact: calcrem(70),
    factSubline: calcrem(26),
    faqHeadline: calcrem(36),
    formHead: calcrem(36),
    formHeadWideScreen: calcrem(44),
    headline1: calcrem(36),
    headline1WideScreen: calcrem(52),
    headline2: calcrem(36),
    headline2WideScreen: calcrem(44),
    headline3: calcrem(24),
    headline3WideScreen: calcrem(28),
    headline4: calcrem(20),
    headline4WideScreen: calcrem(26),
    infoText: calcrem(20),
    jobFactItem: '18px',
    jobListTeaser: calcrem(16),
    jobHeaderHeadline: calcrem(44),
    jobHeaderHeadlineWideScreen: calcrem(52),
    label: calcrem(20),
    landingPageHeadline: '36px',
    landingPageHeadlineWideScreen: '52px',
    locationList: calcrem(28),
    logoButtonHeadline: calcrem(30),
    logoButtonHeadlineWideScreen: calcrem(36),
    paragraph: calcrem(22),
    paragraphWideScreen: calcrem(26),
    placeholder: calcrem(20),
    processItemHeadline: calcrem(20),
    processItemNumber: calcrem(20),
    processSubline: calcrem(30),
    processSublineWideScreen: calcrem(36),
    smallButton: '20px',
    speechBubble: '28px',
    subline: calcrem(30),
    sublineWideScreen: calcrem(36),
    tabsModuleHeadlineWideScreen: '44px',
    text: calcrem(26),
    textWideScreen: calcrem(26),
    typographyHeadline2: calcrem(30),
    typographyHeadline2WideScreen: calcrem(36),
  },
  margins: {
    aboutUs: '40px',
    aboutUsHeadline: '2px',
    aboutUsImageContainer: '0 0 20px',
    appForm: calcrem(62),
    appFormWideScreen: calcrem(80),
    appInfo: calcrem(6),
    appInfoWideScreen: calcrem(20),
    applyStepsContainer: `0 ${calcrem(-15)} ${calcrem(35)}`,
    applyStepsContainerWideScreen: calcrem(80),
    applyStepsDesktop: '0 20px',
    applyStepsHeadline: '10px',
    applyStepsHeadlineWideScreen: '30px',
    applyStepsSubline: calcrem(20),
    applyStepsSublineWideScreen: calcrem(20),
    backBarLink: '12px',
    benefitCarousel: `0 ${calcrem(-15)} ${calcrem(20)}`,
    benefitHeadline: '30px',
    benefitHeadlineWideScreen: '30px',
    benefitListItems: calcrem(44),
    button: calcrem(20),
    buttonWideScreen: calcrem(24),
    cardIcon: '10px',
    cardIconContainer: '20px',
    checkButton: '1px 10px 0 0',
    clientLandingPageParagraph: '20px',
    contact: '0 auto 22px auto',
    contactHeadlineBottom: '16px',
    contactLinkList: calcrem(20),
    contactLinkListWideScreen: '10px',
    contactPictureBottom: '16px',
    contactWideScreenBottom: '24px',
    container: '0 auto 30px',
    containerWideScreenBottom: '60px',
    dateBadge: '9px',
    dateParagraph: '18px',
    details: '32px 0px 42px 32px',
    errorMessage: '0',
    errorMessageHeading: '0',
    errorMessageHeadingWideScreen: '0 0 20px 0',
    errorMessageWideScreen: '-25px 0 20px 0',
    fact: calcrem(20),
    factHeadline: '30px',
    factHeadlineWideScreen: calcrem(45),
    faqHeadline: '0 0 30px',
    faqItemHeadlineWideScreen: '12px',
    fieldRow: calcrem(14),
    fieldRowWideScreen: calcrem(20),
    fileFieldButton: '10px',
    form: '20px',
    formRow: `0 -${calcrem(5)}`,
    formSection: '0 -10px',
    header: '0 -10px',
    headline: calcrem(30),
    headLine: '0 0 20px',
    headLineBottom: '20px',
    headlineTeaser: '10px',
    iconRight: '4px',
    iconWideScreen: '5px 4px 0 0',
    image: '10px',
    imageTeaser: '30px',
    imageTeaserHeadline: '0 0 30px',
    imageTeaserParagraph: '10px',
    imageWideScreen: '20px',
    infoText: calcrem(8),
    jobContent: '30px',
    jobDetailsButton: '30px',
    jobFactHelpText: '-5px',
    jobFactList: '35px',
    jobFactListWideScreen: '32px',
    jobList: '20px',
    jobListButtonBottom: '10px',
    jobListButtonLeft: '10px',
    jobListButtonRight: '20px',
    jobListButtonTop: '20px',
    jobListTeaserFooterLeft: '-100px',
    jobListTeaserFooterTop: '15px',
    jobListTeaserListItem: '10px',
    jobListTeaserListItemIcon: '15px',
    jobMain: '40px',
    jobSearchList: '50px',
    landingPageHeadline: '10px',
    linkListHeadline: calcrem(30),
    linkListIcon: '15px',
    list: '0 -20px',
    listItem: `5px 0px`,
    locationList: '10px 0 0 30px',
    locationListLi: '10px',
    logoButton: '0 -10px 40px',
    media: '20px',
    mobileButton: '30px',
    modalContent: '0 40px',
    modalContentP: '1em',
    modalContentP1th: '0.5em',
    modalContentP5th: '1em',
    modalFooter: '0 0 40px 40px',
    modalHeader: '40px 0 1em 40px',
    multiMediaAboveline: '10px',
    optionContainer: '30px',
    page: '20px',
    pageHead: '30px',
    pageHeadWideScreen: '75px',
    pageWideScreen: '80px',
    paragraphBottom: '20px',
    phoneInput: '0 5px',
    phoneInputWideScreen: '0 15px',
    processCarousel: `0 ${calcrem(-15)} 0`,
    processItem: '0 -10px',
    processItemHeadline: calcrem(6),
    progressBar: '40px',
    searchBoxChildren: '24px',
    searchBoxInput: '20px',
    searchBoxInputWideScreen: '0px',
    secondFooter: calcrem(22),
    secondFooterWideScreen: calcrem(20),
    selectWideScreen: '4px',
    sidebarButton: '18px',
    spacer: '0',
    speechBubble: '20px',
    speechBubbleIcon: '2px 10px 0 0',
    statusBar: '20px',
    tab: '10px',
    templateHeadline: '15px',
    templateIconRight: '20px',
    thankYouTeaserImage: '0',
    twoColTextHeadline: '30px',
  },
  opacities: {
    buttonHover: '0.3',
  },
  overflows: {},
  paddings: {
    container: '0 15px',
    contactLink: '8px',
    contactLinkItem: '0',
    contactLinkItemLink: '8px 12px',
    defaultButton: '10px 14px',
    fact: '0',
    factHeader: '24px',
    factWideScreen: '0',
    faqItemClose: '20px 30px',
    faqItemOpen: '20px 30px',
    fieldGroup: `0 ${calcrem(5)}`,
    fieldGroupWideScreen: `0 ${calcrem(5)}`,
    fileUploadHeadline: `0 ${calcrem(5)}`,
    fileUploadHeadlineWideScreen: `0 ${calcrem(13)}`,
    formField: calcrem(14),
    formFieldWideScreen: calcrem(30),
    formSection: `${calcrem(20)} 0 ${calcrem(14)}`,
    formSectionWideScreen: `${calcrem(24)} 0 ${calcrem(4)}`,
    ghostButtonWideScreen: '15px 20px',
    header: `${calcrem(16)} 0 ${calcrem(18)}`,
    headerWideScreen: `${calcrem(20)} 0 ${calcrem(24)}`,
    imageTeaserWrapper: '15px 20px 20px',
    infoDropDownWideScreen: calcrem(0),
    jobFactItem: '10px 20px',
    jobFactItemWideScreen: '10px 20px',
    jobFactListFirstItem: '15px',
    jobHeaderContainer: '0',
    jobMainContainer: '0 15px',
    jobMainContainerWideScreen: '0',
    landingPageImg: '30px',
    leadFormSection: '24px',
    leadFormSectionWideScreen: '30px',
    linkgeneratorForm: '40px',
    listMarker: '10px',
    panel: '5px 10px',
    processItemContainer: `${calcrem(30)} ${calcrem(12)} ${calcrem(30)}`,
    processItemContainerWideScreen: `${calcrem(30)} 0 ${calcrem(10)}`,
    progressBarContainer: '0 15px',
    progressBarIcon: '10px 10px 10px 0',
    progressBarIconWideScreen: '10px 20px 10px 0',
    smallButton: '10px 16px',
    spacer: '60px 0',
    spacerWideScreen: '70px 0',
    thankYou: '0px',
    thankYouTeaser: '0',
    twoColParagraph: '20px',
    twoColText: '50px',
  },
  positions: {
    doneIcon: 'auto 5px 10px auto',
    doneIconWideScreen: 'auto 10px 10px auto',
    jobListFooterLineLeft: '50%',
    processNumberBottom: '23px',
    processNumberBottomWideScreen: '14px',
    processNumberLeft: '17px',
    processNumberLeftWideScreen: '14px',
    speechBubbleAfterBottom: '-8px',
    speechBubbleAfterLeft: '20px',
  },
  radius: {
    aboutUsImg: '5px',
    baseButton: '12px',
    button: '12px',
    cardInfo: '8px',
    checkBox: '0',
    contactIcon: '50%',
    contactLink: '8px',
    contactLinkItem: '8px',
    dateBadge: '8px',
    factHeader: '12px',
    faqItem: '16px',
    fileField: '12px',
    image: '10px',
    imageTeaser: '10px',
    input: '12px',
    jobFactItem: '8px',
    landingPageHeader: '8px',
    link: '6px',
    logoButton: '12px',
    media: '10px',
    mediaWideScreen: '8px',
    pageHead: '0px',
    panel: '10px',
    processItemImage: '10px 10px 0 0',
    processNumber: '50%',
    progressBar: '8px',
    radioButton: '24px',
    rounded: '50%',
    smallButton: '12px',
    speechBubbleWrapper: '10px',
    statusBar: '4px',
    tab: '5px 5px 0 0',
    teaser: '8px',
    thankYouTeaserImage: '16px',
    wrapper: '6px',
  },
  textAligns: {
    factHeadline: 'left',
  },
  textDecorations: {
    contactLink: 'none',
    location: 'underline',
    footerLink: 'underline',
  },
  textShadows: {
    speechBubble: '0 1px 2px 0 rgba(0, 0, 0, 0.22)',
  },
  urls: {
    listMarker: 'url("/icons/list-arrow.svg")',
    listMarkerBlack: 'url("/icons/list-arrow-black.svg")',
  },
  widths: {
    contactLinkIcon: 14,
    checkMark: calcrem(24),
    container: calcrem(1120),
    factImage: '100px',
    jobListTeaserFooterLeft: '200px',
    processNumber: '35px',
    thankYouTeaser: '350px',
    spacer: '100%',
    spacerMax: '100%',
    jobFactItemIconContainer: '20px',
  },
  zIndex: {
    header: '11',
    inputOverlap: '5',
    modal: '12',
    searchBox: '10',
  },
};

export default defaultTheme;
